export const BUILD_VERSION = '1779981037';
